// Access codes are printed in three-character groups; restore that shape on
// blur whatever the customer typed or pasted.
export function initAccessCodeMask() {
  const input = document.getElementById("access-code");
  if (!input) {
    return;
  }

  input.addEventListener("blur", () => {
    const groups = input.value.replace(/-/g, "").match(/.{1,3}/g);
    input.value = groups ? groups.join("-") : "";
  });
}
